import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '../services/environment.service';
import { Observable } from 'rxjs';
import {
    GetCreativesHeavyAssetMetadataQueryResponse,
    GetCreativesHeavyAssetMetadataRequest
} from '@domain/api/generated/sapi';

@Injectable({
    providedIn: 'root'
})
export class HeavyAssetsDataService {
    private environmentService = inject(EnvironmentService);
    private httpClient = inject(HttpClient);

    loadHeavyAssetsMetadata(
        creativeIds: GetCreativesHeavyAssetMetadataRequest['ids']
    ): Observable<GetCreativesHeavyAssetMetadataQueryResponse | undefined> {
        const url = `${this.environmentService.origins.sapi}/creatives/heavy-asset-metadata`;
        const body: GetCreativesHeavyAssetMetadataRequest = {
            ids: creativeIds
        };
        return this.httpClient.post<GetCreativesHeavyAssetMetadataQueryResponse>(url, body);
    }
}
